import { Component, Inject, OnInit, Pipe, PipeTransform } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase } from 't4core';
import { AssetHistory, AssetInfo, AssetTransactionInfo, CustomerInfo, LocationInfo, LockLogInfo, ServiceGuyInfo, SmartLockInfo } from "../../../../../projects/t4core/src/public-api";
import { T4_ServiceDialog } from "../serviceDialog/serviceDialog";


@Pipe({
  name: 'batteryProcentile'
})
export class BatteryPipeNoke implements PipeTransform {
  transform(value: number): { class: string, icon: string, percentage: number } {
    //Used the values from the T4 Admin App.
    const ceiling = 3000;
    const floor = 2860;

    // Calculate the percentage based on the given range
    let percentage = ((value - floor) / (ceiling - floor)) * 100;

    // Round the percentage to remove any decimals and make sure that cant be more then 100 and less then 0.
    percentage = Math.round(Math.max(0, Math.min(100, percentage)));

    // Determine the CSS class based on the percentage
    let cssClass = '';
    if (percentage < 15) {
      cssClass = 'battery-low';
    } else if (percentage < 30) {
      cssClass = 'battery-medium';
    } else {
      cssClass = 'battery-high';
    }

    // Determine the mat icon based on the percentage
    let icon = '';
    if (percentage >= 100) {
      icon = 'battery_full';
    } else if (percentage >= 85) {
      icon = 'battery_6_bar';
    } else if (percentage >= 67) {
      icon = 'battery_5_bar';
    } else if (percentage >= 50) {
      icon = 'battery_4_bar';
    } else if (percentage >= 33) {
      icon = 'battery_3_bar';
    } else if (percentage >= 15) {
      icon = 'battery_2_bar';
    } else if (percentage > 0) {
      icon = 'battery_1_bar';
    } else {
      icon = 'battery_0_bar';
    }

    return { class: cssClass, icon: icon, percentage: percentage };
  }
}

@Component({
  selector: 'owa-serviceDialog',
  templateUrl: 'assetInformationDialog.html',
  styleUrls: ['./assetInformationDialog.css']
})

export class AssetInformationDialog extends DialogBase implements OnInit {

  public Asset: AssetInfo;

  public CustomerInfo: CustomerInfo;

  public RentalLocations: LocationInfo[];

  public InventoryAsset: AssetHistory;

  public lockLogs: LockLogInfo[];

  public Lock: SmartLockInfo;
  public ServiceGuy: ServiceGuyInfo;
  public AssetTransactions: AssetTransactionInfo


  public batteryLevel: string = "";

  constructor(
    public dialogRef: MatDialogRef<T4_ServiceDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any, /* AssetInfo */
    private fb: FormBuilder
  ) {
    super("AssetInformationDialog");  

    if (data != null)
      this.Asset = data;  
  }

  public async ngOnInit() {

    await this.GetGeneralDetails();

    await this.GetInventorAssetTransactions();

    await this.GetLockLog();

    console.log(this.InventoryAsset);

  }


  public async GetGeneralDetails() {
    this.Lock = await this.Api.get<SmartLockInfo>("/Service/GetGeneralLockInfo", { id: this.Asset.SerialId });
    this.Asset = await this.Api.get<AssetInfo>("/Service/GetAssetInfo", { id: this.Asset.Id });
  }

  
  public async GetRentalLocations() {
    this.RentalLocations = await this.Api.get<LocationInfo[]>("Service/GetRentalLocations"); 
  }


  public async GetAssetTransactions() {
    if(this.Asset)
      this.AssetTransactions = await this.Api.get<AssetTransactionInfo>("/Service/GetAssetTransactions", { AssetId: this.Asset.Id });
  }
  

  public async GetInventorAssetTransactions() {
    if (this.Asset)
      this.InventoryAsset = await this.Api.get<AssetHistory>("/Service/GetAssetHistory", { AssetId: this.Asset.Id });
  }

  public async GetLockLog() {
    if (this.Lock)
      this.lockLogs = await this.Api.get<LockLogInfo[]>("/Service/LockLogs", { lockId: this.Lock.Mac });
  }


  public async GetCustomerInfo(contextId) {

    var ret = await this.UI.openDialog('T4.Service.T4LocationLink',
      {
        value: 123,
    });
  } 
}
